export default "__VITE_ASSET__B9ZGqJf5__"